import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\ProjectAssetController::index
* @see Http/Controllers/ProjectAssetController.php:35
* @route '/projects/{project}/assets'
*/
export const index = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/projects/{project}/assets',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ProjectAssetController::index
* @see Http/Controllers/ProjectAssetController.php:35
* @route '/projects/{project}/assets'
*/
index.url = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { project: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
    }

    return index.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ProjectAssetController::index
* @see Http/Controllers/ProjectAssetController.php:35
* @route '/projects/{project}/assets'
*/
index.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProjectAssetController::index
* @see Http/Controllers/ProjectAssetController.php:35
* @route '/projects/{project}/assets'
*/
index.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ProjectAssetController::index
* @see Http/Controllers/ProjectAssetController.php:35
* @route '/projects/{project}/assets'
*/
const indexForm = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProjectAssetController::index
* @see Http/Controllers/ProjectAssetController.php:35
* @route '/projects/{project}/assets'
*/
indexForm.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProjectAssetController::index
* @see Http/Controllers/ProjectAssetController.php:35
* @route '/projects/{project}/assets'
*/
indexForm.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\ProjectAssetController::store
* @see Http/Controllers/ProjectAssetController.php:49
* @route '/projects/{project}/assets'
*/
export const store = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/projects/{project}/assets',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ProjectAssetController::store
* @see Http/Controllers/ProjectAssetController.php:49
* @route '/projects/{project}/assets'
*/
store.url = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { project: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
    }

    return store.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ProjectAssetController::store
* @see Http/Controllers/ProjectAssetController.php:49
* @route '/projects/{project}/assets'
*/
store.post = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ProjectAssetController::store
* @see Http/Controllers/ProjectAssetController.php:49
* @route '/projects/{project}/assets'
*/
const storeForm = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ProjectAssetController::store
* @see Http/Controllers/ProjectAssetController.php:49
* @route '/projects/{project}/assets'
*/
storeForm.post = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\ProjectAssetController::serve
* @see Http/Controllers/ProjectAssetController.php:78
* @route '/projects/{project}/assets/{asset}/serve'
*/
export const serve = (args: { project: string | number | { id: string | number }, asset: string | number | { id: string | number } } | [project: string | number | { id: string | number }, asset: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: serve.url(args, options),
    method: 'get',
})

serve.definition = {
    methods: ["get","head"],
    url: '/projects/{project}/assets/{asset}/serve',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ProjectAssetController::serve
* @see Http/Controllers/ProjectAssetController.php:78
* @route '/projects/{project}/assets/{asset}/serve'
*/
serve.url = (args: { project: string | number | { id: string | number }, asset: string | number | { id: string | number } } | [project: string | number | { id: string | number }, asset: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            project: args[0],
            asset: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
        asset: typeof args.asset === 'object'
        ? args.asset.id
        : args.asset,
    }

    return serve.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace('{asset}', parsedArgs.asset.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ProjectAssetController::serve
* @see Http/Controllers/ProjectAssetController.php:78
* @route '/projects/{project}/assets/{asset}/serve'
*/
serve.get = (args: { project: string | number | { id: string | number }, asset: string | number | { id: string | number } } | [project: string | number | { id: string | number }, asset: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: serve.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProjectAssetController::serve
* @see Http/Controllers/ProjectAssetController.php:78
* @route '/projects/{project}/assets/{asset}/serve'
*/
serve.head = (args: { project: string | number | { id: string | number }, asset: string | number | { id: string | number } } | [project: string | number | { id: string | number }, asset: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: serve.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ProjectAssetController::serve
* @see Http/Controllers/ProjectAssetController.php:78
* @route '/projects/{project}/assets/{asset}/serve'
*/
const serveForm = (args: { project: string | number | { id: string | number }, asset: string | number | { id: string | number } } | [project: string | number | { id: string | number }, asset: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: serve.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProjectAssetController::serve
* @see Http/Controllers/ProjectAssetController.php:78
* @route '/projects/{project}/assets/{asset}/serve'
*/
serveForm.get = (args: { project: string | number | { id: string | number }, asset: string | number | { id: string | number } } | [project: string | number | { id: string | number }, asset: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: serve.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProjectAssetController::serve
* @see Http/Controllers/ProjectAssetController.php:78
* @route '/projects/{project}/assets/{asset}/serve'
*/
serveForm.head = (args: { project: string | number | { id: string | number }, asset: string | number | { id: string | number } } | [project: string | number | { id: string | number }, asset: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: serve.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

serve.form = serveForm

/**
* @see \App\Http\Controllers\ProjectAssetController::update
* @see Http/Controllers/ProjectAssetController.php:95
* @route '/projects/{project}/assets/{asset}'
*/
export const update = (args: { project: string | number | { id: string | number }, asset: string | number | { id: string | number } } | [project: string | number | { id: string | number }, asset: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

update.definition = {
    methods: ["patch"],
    url: '/projects/{project}/assets/{asset}',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\ProjectAssetController::update
* @see Http/Controllers/ProjectAssetController.php:95
* @route '/projects/{project}/assets/{asset}'
*/
update.url = (args: { project: string | number | { id: string | number }, asset: string | number | { id: string | number } } | [project: string | number | { id: string | number }, asset: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            project: args[0],
            asset: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
        asset: typeof args.asset === 'object'
        ? args.asset.id
        : args.asset,
    }

    return update.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace('{asset}', parsedArgs.asset.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ProjectAssetController::update
* @see Http/Controllers/ProjectAssetController.php:95
* @route '/projects/{project}/assets/{asset}'
*/
update.patch = (args: { project: string | number | { id: string | number }, asset: string | number | { id: string | number } } | [project: string | number | { id: string | number }, asset: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\ProjectAssetController::update
* @see Http/Controllers/ProjectAssetController.php:95
* @route '/projects/{project}/assets/{asset}'
*/
const updateForm = (args: { project: string | number | { id: string | number }, asset: string | number | { id: string | number } } | [project: string | number | { id: string | number }, asset: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ProjectAssetController::update
* @see Http/Controllers/ProjectAssetController.php:95
* @route '/projects/{project}/assets/{asset}'
*/
updateForm.patch = (args: { project: string | number | { id: string | number }, asset: string | number | { id: string | number } } | [project: string | number | { id: string | number }, asset: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\ProjectAssetController::destroy
* @see Http/Controllers/ProjectAssetController.php:112
* @route '/projects/{project}/assets/{asset}'
*/
export const destroy = (args: { project: string | number | { id: string | number }, asset: string | number | { id: string | number } } | [project: string | number | { id: string | number }, asset: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/projects/{project}/assets/{asset}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\ProjectAssetController::destroy
* @see Http/Controllers/ProjectAssetController.php:112
* @route '/projects/{project}/assets/{asset}'
*/
destroy.url = (args: { project: string | number | { id: string | number }, asset: string | number | { id: string | number } } | [project: string | number | { id: string | number }, asset: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            project: args[0],
            asset: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
        asset: typeof args.asset === 'object'
        ? args.asset.id
        : args.asset,
    }

    return destroy.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace('{asset}', parsedArgs.asset.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ProjectAssetController::destroy
* @see Http/Controllers/ProjectAssetController.php:112
* @route '/projects/{project}/assets/{asset}'
*/
destroy.delete = (args: { project: string | number | { id: string | number }, asset: string | number | { id: string | number } } | [project: string | number | { id: string | number }, asset: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\ProjectAssetController::destroy
* @see Http/Controllers/ProjectAssetController.php:112
* @route '/projects/{project}/assets/{asset}'
*/
const destroyForm = (args: { project: string | number | { id: string | number }, asset: string | number | { id: string | number } } | [project: string | number | { id: string | number }, asset: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ProjectAssetController::destroy
* @see Http/Controllers/ProjectAssetController.php:112
* @route '/projects/{project}/assets/{asset}'
*/
destroyForm.delete = (args: { project: string | number | { id: string | number }, asset: string | number | { id: string | number } } | [project: string | number | { id: string | number }, asset: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const assets = {
    index: Object.assign(index, index),
    store: Object.assign(store, store),
    serve: Object.assign(serve, serve),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
}

export default assets